import { PayeeRequirement } from "@wingspanhq/wingspan-api-sdk";

import { selectorRequirementExpirationDate } from "./selectorRequirementExpirationDate";

const ONE_DAY_IN_MS = 24 * 60 * 60 * 1000;

export const selectorIsRequirementExpiringInDays = (
  requirement: PayeeRequirement
) => {
  const expirationDate = selectorRequirementExpirationDate(requirement);
  const diff = expirationDate ? expirationDate?.getTime() - Date.now() : 0;

  return Math.round(diff / ONE_DAY_IN_MS) || 0;
};
